// extracted by mini-css-extract-plugin
module.exports = {"button":"style_button__SsIT6","loading":"style_loading__ah35n"};